module.exports = __webpack_public_path__ + "img/rhone_logo.ad79dc76.png";